// create axios instance
import axios from "axios";

// create an axios instance
const httpClient = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "https://api.uniquemedicos.com"
      : "https://api.uniquemedicos.com",
});

// Add a request interceptor
httpClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Check if the error is due to an expired token
    if (error.response?.status === 401) {
      // Remove token and user from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      // Redirect to login page
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default httpClient;
